{
  "navx-smartlink-full-picture-auth-nudge.connect-button": [
    {
      "type": 0,
      "value": "Connect"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.connected-button": [
    {
      "type": 0,
      "value": "Connected"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.connecting-label": [
    {
      "type": 0,
      "value": "Connecting"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.description": [
    {
      "type": 0,
      "value": "Connect to preview what's inside. Your teammates have connected this app."
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.description-success": [
    {
      "type": 0,
      "value": "Links now display as synced previews"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.description-with-org-stat": [
    {
      "type": 0,
      "value": "Connect to preview what's inside. "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "percent"
        },
        {
          "type": 0,
          "value": "%"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of your organization has connected this app."
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.dont-show-again-button": [
    {
      "type": 0,
      "value": "Don't show this again"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.reload-to-see-previews": [
    {
      "type": 0,
      "value": "Reload to see previews"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.title": [
    {
      "type": 0,
      "value": "See what's behind these "
    },
    {
      "type": 1,
      "value": "providerName"
    },
    {
      "type": 0,
      "value": " links"
    }
  ],
  "navx-smartlink-full-picture-auth-nudge.title-success": [
    {
      "type": 1,
      "value": "providerName"
    },
    {
      "type": 0,
      "value": " connected"
    }
  ]
}